import { getPublicKey } from '../store/Slices/authSlice';
// import JSEncrypt from 'jsencrypt'; // Remove or comment out jsencrypt import
import forge from 'node-forge';

export async function fetchAndStorePublicApi(dispatch) {
    try {
        const response = await dispatch(getPublicKey()).unwrap();
        // Assuming the key is directly in response.publicKey and is PEM formatted
        const publicKeyPEM = response?.publicKey;

        if (publicKeyPEM) {
            // Store the PEM formatted public key
            localStorage.setItem('publicKey', publicKeyPEM);
            console.log('Public key successfully stored in local storage.');
        } else {
            console.error('Public key not found in the response.');
        }
    } catch (error) {
        console.error('Error fetching public key:', error);
    }
}

export function encryptData(data, publicKey) {
    try {
      // Convert the public key from PEM format to a forge public key object
      const publicKeyForge = forge.pki.publicKeyFromPem(publicKey);
  
      // Encrypt the data
      const encryptedData = publicKeyForge.encrypt(data, "RSA-OAEP", {
        md: forge.md.sha256.create(),
        mgf1: forge.mgf.mgf1.create(forge.md.sha256.create()),
      });
  
      // Return the encrypted data in base64 format
      return forge.util.encode64(encryptedData);
    } catch (error) {
      console.error("Encryption failed:", error);
      throw new Error("Encryption failed");
    }
  }